module.exports = __webpack_public_path__ + "109a9bff087942e84f2bd887f24f42c6.png";